import { useEffect, useState } from 'react'
import { Link, useSearchParams } from 'react-router-dom'
import { searchPages } from '@/api/wiki'
import type { WikiPage } from '@/types/wiki'

export default function SearchPage() {
  const [params] = useSearchParams()
  const q = params.get('q') || ''
  const [results, setResults] = useState<WikiPage[]>([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (q.length < 2) return
    setLoading(true)
    searchPages(q)
      .then(setResults)
      .catch(() => setResults([]))
      .finally(() => setLoading(false))
  }, [q])

  return (
    <div className="panel p-6 sm:p-8">
      <h1 className="text-2xl font-display text-calamity-text mb-6">
        Search results for "{q}"
      </h1>

      {loading && (
        <div className="text-calamity-text-dim">Searching...</div>
      )}

      {!loading && results.length === 0 && q.length >= 2 && (
        <div className="text-center py-12">
          <div className="text-4xl mb-3 opacity-50">&#128269;</div>
          <p className="text-calamity-text-dim">No results found for "{q}"</p>
        </div>
      )}

      {!loading && results.length > 0 && (
        <div className="space-y-3">
          {results.map(page => (
            <Link
              key={page.id}
              to={`/${page.slug}`}
              className="block p-4 rounded-xl bg-calamity-bg-dark/50 border border-calamity-border-subtle hover:border-calamity-accent/30 transition-colors"
            >
              <div className="flex items-center gap-2 mb-1">
                <span className="text-lg">{page.icon || '\uD83D\uDCC4'}</span>
                <span className="font-semibold text-calamity-text">{page.title}</span>
              </div>
              {page.meta_description && (
                <p className="text-sm text-calamity-text-dim ml-7">{page.meta_description}</p>
              )}
              {page.category_name && (
                <span className="inline-block ml-7 mt-1 text-[10px] px-2 py-0.5 rounded-full bg-calamity-accent/10 text-calamity-accent">
                  {page.category_name}
                </span>
              )}
            </Link>
          ))}
        </div>
      )}
    </div>
  )
}
